import { useNavigate } from "react-router-dom";
import ServiceDetailsHeader from "../components/Common/ImageHeader";
import ServiceDetailsContents from "../components/OurService/ServiceContents";
import ServiceFeatures from "../components/OurService/ServiceFeatures";
import FeedbackSection from "../components/Common/Feedback";
import CurrentUser from "../components/OurService/CurrentUser";
import CaseStudies from "../components/Common/CaseStudiesSection";
import { homePageTestimonialConfig } from '../components/Common/DifferentFeedbackConfig';
import { clientFeedbackService, formatClientFeedbackData } from "../services/clientFeedbackService";
import { useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import { servicesService } from "../services/servicesService";
import {
  Text,
  Spinner,
  Center,
} from "@chakra-ui/react";
const ServiceDetails = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  
  const [service, setService] = useState(null);
  const [testimonials, setTestimonials] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const handleBreadcrumbClick = (href) => {
    if (href && href !== "#") {
      navigate(href);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      if (!id) {
        setError('Service ID not provided');
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        
        // Fetch service details
        const serviceResult = await servicesService.getServiceById(id);
        if (serviceResult.success) {
          setService(serviceResult.data);
        } else {
          setError(serviceResult.error || 'Failed to fetch service details');
        }

        // Fetch client feedback data
        const feedbackResponse = await clientFeedbackService.getClientFeedback();
        if (feedbackResponse.success && feedbackResponse.data) {
          const formattedTestimonials = formatClientFeedbackData(feedbackResponse.data);
          setTestimonials(formattedTestimonials);
        }
      } catch (err) {
        setError('An error occurred while fetching data');
        console.error('Data fetch error:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id]);

  if (loading) {
    return (
      <Center h="100vh">
        <Spinner size="xl" color="#000B8C" />
      </Center>
    );
  }

  if (error) {
    return (
      <Center h="100vh">
        <Text color="red.500">Error: {error}</Text>
      </Center>
    );
  }

  if (!service) {
    return (
      <Center h="100vh">
        <Text>Service not found</Text>
      </Center>
    );
  }

  const title = service.imageHeader?.title || service.solutionTitle;
  const description = service.description;
  
  // Construct full image URL
  const strapiBaseUrl = process.env.REACT_APP_API_URL?.replace('/api', '');
  const backgroundImageUrl = service.imageHeader?.headerImage?.url 
    ? `${strapiBaseUrl}${service.imageHeader.headerImage.url}`
    : "/png/eGovernment-Solution.png"; // fallback image

  return (
    <>
      <ServiceDetailsHeader
        title={title || "Service Details"} 
        backgroundImage={backgroundImageUrl}
        breadcrumbItems={[
          { label: "Home", href: "/" },
          { label: "Services", href: "/our-services" },
          { label: title || "Service Details", href: "#", isCurrentPage: true },
        ]}
        onBreadcrumbClick={handleBreadcrumbClick}
      />
      {/* <ServiceDetailsContents 
        title={service.solutionTitle || "Benefits of Our Service"}
        description={description}
        benefits={service.solutionsPoints?.map(point => ({
          id: point.id,
          title: point.solutionsPoint,
          content: point.solutionsDesc
        })) || []}
      /> */}
      
      {/* Service Features Component */}
      {/* <ServiceFeatures 
        serviceFeatures={service.serviceFeatures || []}
        featureTitle={service.featureTitle || "Key Features & Specifications"}
      /> */}

      {/* <FeedbackSection
        testimonials={testimonials}
        config={homePageTestimonialConfig}
      /> */}
      {/* <CurrentUser />
      <CaseStudies /> */}
    </>
  );
};

export default ServiceDetails;
